module.exports = __webpack_public_path__ + "media/images/background/5-5818221e9a460429451ba6d9c5801e84.jpg";